export class User {
  firstname: string;

  lastname: string;

  email: string;

  phone: number;

  address1: string;

  address2: string;

  state: string;

  city: string;

  zipcode: number;
}



// WEBPACK FOOTER //
// ./src/app/models/user.ts